// main.component.ts
import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationExtras } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/services/auth.service';
import { HttpService } from 'src/app/shared/services/http.service';
import { calendarioService } from 'src/app/shared/services/calendario.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [
    trigger('submenu', [
      state('hidden', style({ height: '0', overflow: 'hidden', opacity: 0 })),
      state('visible', style({ height: '*', overflow: 'hidden', opacity: 1 })),
      transition('visible <=> hidden', [animate('250ms cubic-bezier(0.86, 0, 0.07, 1)')])
    ])
  ]
})
export class MainComponent implements OnInit {

  isDarkMode = false;
  sidebarVisible = true;
  logoSrc = 'assets/images/full-logo.png';

  menuItems: any[] = [];
  user: any = {};
  numeroTareas = 0;
  displayDialog = false;
  objetonuevo: any[] = [];
  catEventosCalendario: any[] = [];

  constructor(
    private router: Router,
    public auth: AuthService,
    private http: HttpService,
    private calendarioServicio: calendarioService,
    private messageService: MessageService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (this.auth.user) this.user = this.auth.user;
  }

  ngOnInit(): void {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') this.setDarkTheme();
    else this.setLightTheme();

    if (!this.auth.user || !this.auth.user.permissions) {
      this.http.getPermissions().then((permissions: any[]) => {
        this.auth.permissions = permissions;
        this.user = this.auth.user;
        this.buildMenu(permissions);
      });
    } else {
      this.buildMenu(this.auth.user.permissions);
    }

    this.obtenerTareas();

    // Mejora UX móvil: si arranca en móvil, sidebar cerrado
    if (window.innerWidth < 992) this.sidebarVisible = false;
  }

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    this.isDarkMode ? this.setDarkTheme() : this.setLightTheme();
  }

  setDarkTheme() {
    this.isDarkMode = true;
    this.renderer.addClass(this.document.body, 'dark-theme');
    localStorage.setItem('theme', 'light'); //se cambio light por dark 
    this.logoSrc = 'assets/images/full-logo.png';
  }

  setLightTheme() {
    this.isDarkMode = false;
    this.renderer.removeClass(this.document.body, 'dark-theme');
    localStorage.setItem('theme', 'light');
    this.logoSrc = 'assets/images/full-logo.png';
  }

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  obtenerTareas() {
    this.calendarioServicio.getTareas().subscribe((tareas) => {
      this.catEventosCalendario = tareas || [];
      this.objetonuevo = this.catEventosCalendario.map((tarea) => ({
        ...tarea,
        campoAgregado: new Date(tarea.start).toLocaleString()
      }));
      this.numeroTareas = this.catEventosCalendario.length;
    });
  }

  buildMenu(modules: any[]) {
    // Si tu backend no trae icono por módulo, se va a "folder" por default
    this.menuItems = (modules || []).map(m => ({
      label: m.description,
      icon: m.icon || 'folder',   // <- NUEVO (opcional)
      expanded: false,
      items: (m.options || []).map((o: any) => ({
        label: o.description,
        icon: `pi pi-fw pi-${o.icon}`,
        route: o.route,
        id: o.id
      }))
    }));
  }

  toggleGroup(item: any) {
    const next = !item.expanded;
    this.menuItems.forEach((group) => {
      group.expanded = group === item ? next : false;
    });
  }

  navigate(item: any) {
    if (window.innerWidth < 992) this.sidebarVisible = false;
    const extras: NavigationExtras = { state: { optionId: item.id } };
    this.router.navigate([item.route], extras);
  }

  salir() {
    this.auth.clearCredentials();
    this.router.navigate(['/login']);
  }

  showDialog() {
    this.displayDialog = true;
  }
}
